import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cargando from './Cargando';
import {MyContext} from '../contexts/MyContext';
 
export const LoginRoute = ({ component: Component, ...rest}) => {
    const contexto = useContext(MyContext);

    return (
            <Route
            {...rest}
            render={ () => {
                return (contexto.rootState.isAuth === '' ?
                            <Cargando/>
                        :
                            (contexto.rootState.isAuth === false) ?
                                <Component/>
                            :
                                <Redirect to='/'/>
                )
            }}
            />
    )
}